import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Image } from 'react-bootstrap';



function MejoraRegulatoria() {
  const [selectedOption, setSelectedOption] = useState('');

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleLinkButtonClick = () => {
    let link = '';
    if (selectedOption === '1') {
      link = '../Pdf/PAMR2020.pdf';
    } else if (selectedOption === '2') {link = '../Pdf/PAMR2021.pdf';
    } else if (selectedOption === '3') {link = '../Pdf/PAMR2022.pdf';
    } else if (selectedOption === '4') {link = '../Pdf/PAMR2023.pdf';
    } else if (selectedOption === '5') {link = '../Pdf/PAMR2024.pdf';
    } else if (selectedOption === '6') {link = '../Pdf/PAMR2025.pdf';

    }
    window.open(link, '_blank');
  };

  return (

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <div style={{ maxWidth: '300px' }}>
            </div>              <Card.Text>Mejora Regulatoria</Card.Text>
              <Form.Select
                aria-label="Default select example"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option>- - -</option>
                <option value="1">2020</option>
                <option value="2">2021</option>
                <option value="3">2022</option>
                <option value="4">2023</option>
                <option value="5">2024</option>
                <option value="6">2025</option>
              </Form.Select>
              <Button variant="primary" onClick={handleLinkButtonClick}>Ver</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

  );
}

export default MejoraRegulatoria;
